<template>
  <div>
    <span v-if="row.order">{{ row.order.out_trade_no }}</span>
    <span v-else-if="row.ccr_order">{{ row.ccr_order.out_trade_no }}</span>
  </div>
</template>

<script>
export default {
  name: 'MerchantNum',
  components: { },
  props: {
    row: {
      type: Object,
      required: true
    },
    prop: {
      type: String,
      required: true
    }
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/coupon_codes/common/MerchantNum.vue